export default __webpack_public_path__ + "static/donair-1-858ddad1583c60417aa5d472ba23f3a6.jpg";